// extracted by mini-css-extract-plugin
module.exports = {"filtersButton":"FilterButton_filtersButton__gOsKP","active":"FilterButton_active__KKc1m","remove":"FilterButton_remove__LwmxZ"};